
import React from 'react';
import ReactDom from 'react-dom';
import FileUploader from "./FileUploader";
import request from 'superagent';

const EMAIL_PATTERN = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

class ContactForm extends React.Component
{
    constructor() {
        super(...arguments);
        this.state = {
            step: 0,
            total_section: 6,
            files: [],
            busy: false,
        };
        this.sent = false;
        this.input = {};
    }

    handleInput(e) {
        this.input[e.target.name] = e.target.value;
        this.setState({ input: this.input });
    }

    adjustSize() {
        let height = 0;
        // $(ReactDom.findDOMNode(this.refs.contact_form)).find('.section').each(function(){
        //     height = Math.max(height, $(this).outerHeight());
        // });
        $(ReactDom.findDOMNode(this.refs.contact_form)).find('.section').removeClass('is-shown');
        height = $(ReactDom.findDOMNode(this.refs.contact_form)).find('.section.is-active').addClass('is-shown').outerHeight();
        $(ReactDom.findDOMNode(this.refs.placeholder)).css('height', height);

        if (this.scroll_timer) {
            clearTimeout(this.scroll_timer);
            this.scroll_timer = null;
        }
        this.scroll_timer = setTimeout(() => {
            if (this.state.step > 0) {
                const $form = $(ReactDom.findDOMNode(this.refs.contact_form));
                console.log('TTT', ($(window).innerHeight() - $form.height()) / 2);
                $('html, body').animate({
                    scrollTop: $form.offset().top - Math.abs(($(window).innerHeight() - $form.height()) / 2)
                });
            }
        }, 300);
    }

    renderView(step) {
        const state = this.state || {};
        const input = this.input || {};
        switch (step) {
            case 0:
                return (
                    <div className={`has-text-centered`}>
                        <h2 className={`title is-4`}>{app.trans('contact.get_in_touch_with_us')}</h2>
                        <div className="field is-narrow field-email">
                            <input type="email" onChange={this.handleInput.bind(this)} className={`input`} placeholder={app.trans('contact.email_placeholder')} name={`email`}/>
                        </div>
                        <div className="field is-narrow field-name">
                            <input type="text" onChange={this.handleInput.bind(this)} className={`input`} placeholder={app.trans('contact.name_placeholder')} name={`name`}/>
                        </div>
                        <div className="field">
                            <button className={`button is-primary`} onClick={this.goNext.bind(this)} disabled={!this.isStepOk(step)}>{app.trans('contact.start')}</button>
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div className={`has-text-centered`}>
                        <h2 className={`title is-4`}>{app.trans('contact.what_can_we_help')}</h2>
                        <div className="field">
                            <div className="columns is-multiline is-centered">
                                <div className="column is-4">
                                    <div className="option" onClick={this.goNext.bind(this, {t:'dev'})}>
                                        <h3 className="title is-5">{app.trans('contact.app_development')}</h3>
                                    </div>
                                </div>
                                <div className="column is-4">
                                    <div className="option" onClick={this.goNext.bind(this, {t:'other'})}>
                                        <h3 className="title is-5">{app.trans('contact.other')}</h3>
                                    </div>
                                </div>
                                {/*<div className="column is-4">*/}
                                {/*    <div className="option" onClick={this.goNext.bind(this, {t:'other'})}>*/}
                                {/*        <h3 className="title is-5">in2dream自社サービスに関する<br/>お問い合わせ</h3>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                {/*<div className="column is-4">*/}
                                {/*    <div className="option" onClick={this.goNext.bind(this, {t:'recruit'})}>*/}
                                {/*        <h3 className="title is-5">求人に応募したい</h3>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className={`has-text-centered`}>
                        <h2 className={`title is-4`}>{app.trans('contact.are_you_individual')}<br className={`is-hidden-tablet`}/>{app.trans('contact.or_corporation')}</h2>
                        <div className="field">
                            <div className="columns is-multiline is-centered">
                                <div className="column is-4">
                                    <div className="option" onClick={this.goNext.bind(this, {ctm_t:'personal'})}>
                                        <h3 className="title is-5">{app.trans('contact.individual')}</h3>
                                    </div>
                                </div>
                                <div className="column is-4">
                                    <div className="option" onClick={this.goNext.bind(this, {ctm_t:'corporation'})}>
                                        <h3 className="title is-5">{app.trans('contact.corporation')}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field">
                            <div className="in2-sp"></div>
                            <a className={`button is-light`} onClick={this.goBack.bind(this)}>
                                <span>{app.trans('btn.back')}</span>
                            </a>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className={`is-max-width-tablet`}>
                        <div className="field">
                            <h2 className={`title is-4`}>{app.trans('contact.tell_us_the_detail')}</h2>
                            <h3 className={`subtitle is-6`}>{app.trans('contact.tell_us_the_detail_note')}</h3>
                        </div>
                        <div className="field">
                            FROM: {this.input.name ? <><strong>{this.input.name}</strong> ({this.input.email})</> : <strong>{this.input.email}</strong> }
                        </div>
                        <div className="field">
                            <div className="in2-contact-input">
                                <textarea className="textarea" placeholder={app.trans('contact.content_placeholder')} onChange={this.handleInput.bind(this)} rows={parseInt($(window).innerHeight() * .6 / 50)} name={`content`} defaultValue={this.input.content||''}/>
                            </div>
                            <p className="help">
                                {app.trans('contact.content_help')}
                            </p>
                        </div>
                        <div className="field">
                            <FileUploader fieldName={'files'} formId={this.props.formId} callback={(files) => this.setState({ files: files })}/>
                        </div>
                        <div className="field is-grouped is-grouped-centered">
                            <p className="control">
                                <button className={`button is-primary`} onClick={this.goNext.bind(this)} disabled={!this.isStepOk(step)}>{app.trans('contact.confirm_content')}</button>
                            </p>
                            <div className="control">
                                <a className={`button is-light`} onClick={this.goBack.bind(this)}>
                                    <span>{app.trans('btn.back')}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                );
            case 4:
                return (
                    <div className={`is-max-width-tablet`}>
                        <div className="field">
                            <h2 className={`title is-4`}>{app.trans('contact.confirm_contact_content')}</h2>
                            <h3 className={`subtitle is-6`}>{app.trans('contact.confirm_contact_content_des')}</h3>
                        </div>
                        <div className="field">
                            FROM: {this.input.name ? <><strong>{this.input.name}</strong> ({this.input.email})</> : <strong>{this.input.email}</strong> }
                        </div>
                        <div className="field">
                            <div className="content contact-content" style={{height: (parseInt($(window).innerHeight() * (state.files.length > 0 ? .6 : .8) / 50) * 2) + 'rem'}}>
                                {(this.input.content || '').split(/\n/).map((v, i) => <p key={`c-${i}`}>{v}</p>)}
                            </div>
                        </div>
                        <div className="field">
                            <div className={`in2-image-uploader-container`}>
                                <div className="form-file">
                                    {this.state.files.map((file, i) => {
                                        return (
                                            <div className={`file-item`} key={`file-${file.id}`}>
                                                {file.type && file.type.startsWith('image') ? (
                                                    <div className="type-image"
                                                         style={{ backgroundImage: `url(${file.src})`}}/>
                                                ) : (
                                                    <div className={`type-file`}>
                                                        <span className={`icon is-large`}>
                                                            <i className="fas fa-file"></i>
                                                        </span>
                                                        <div className={`name is-size-7`}>{file.name}</div>
                                                    </div>
                                                )}
                                                <input type="hidden" name={`files[]`} defaultValue={file.value}/>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="field is-grouped is-grouped-centered">
                            <div className="control">
                                <button className={`button is-primary${this.state.busy ? ' is-loading' : ''}`} onClick={this.submitData.bind(this)}>{app.trans('btn.send')}</button>
                            </div>
                            <div className="control">
                                <button className={`button is-light`} onClick={this.goBack.bind(this)}>{app.trans('btn.edit')}</button>
                            </div>
                        </div>
                    </div>
                );
            case 5:
                return (
                    <div className={`has-text-centered`}>
                        <div className="field">
                            <h3 className={`title`}>{app.trans('contact.sent')}</h3>
                            <h4 className={`subtitle`}>{app.trans('contact.sent_message')}<br/>{app.trans('contact.please_wait')}</h4>
                        </div>
                    </div>
                )
        }

        return null;
    }

    goNext(...args) {
        if (args.length > 1) {
            const data = args[0];
            console.log('with_data', data);
            if (typeof(data) === 'function') {
                data();
            }
            Object.keys(data).forEach(k => {
                this.input[k] = data[k];
            });
        }
        if (this.isStepOk(this.state.step)) {
            this.setState({ step: this.state.step + 1 });
            setTimeout(() => this.adjustSize(), 100);
        }
    }

    goBack() {
        this.setState({ step: this.state.step - 1 });
        setTimeout(() => this.adjustSize(), 100);
    }

    submitData() {
        if (this.state.busy) {
            return;
        }
        this.state.busy = true;
        this.setState({
            busy: true
        });
        const data = {};
        data[$('meta[name=csrf_name]').attr('content')] = $('meta[name=csrf]').attr('content');
        data.files = this.state.files.map(v => v.value);

        const send_data = Object.assign(data, this.input);
        console.log(send_data);

        request.post('/contact/send').type('json').send(send_data).ok((res) => {
            if (res.body.sent) {
                this.sent = true;
                this.goNext();
            }
            this.setState({busy: false})
        }).catch(err => {
            this.setState({ error : err, busy: false });
        });
    }

    isStepOk(step) {
        const input = this.input || {};
        switch (step) {
            case 0:
                return input.email && EMAIL_PATTERN.test(input.email);
            case 1:
                return ['dev', 'other'].indexOf(input.t) >= 0;
            case 2:
                return ['personal', 'corporation'].indexOf(input.ctm_t) >= 0;
            case 3:
                return input.content && input.content.trim().length > 20;
            case 4:
                return true;
        }
        return false;
    }

    componentDidMount() {
        window.onbeforeunload = (e) => {
            if (this.state.step > 2 && this.state.step < 5 && input.content.length > 0) {
                e.returnValue = app.trans('contact.quit_warning');
            }
        };
        app.onWindowResize('contact-form', () => this.adjustSize(), {vertical: false});
        this.adjustSize();
    }

    render() {
        const total_section = this.state.total_section;
        return (
            <div className={`contact-form`} ref={`contact_form`}>
                <div className="placeholder" ref={`placeholder`}/>
                {(new Array(total_section)).fill(1).map((v, i) => {
                    return (
                        <div onClick={(e) => e.stopPropagation()}
                             className={`section ${this.state.step === i ? 'is-active' : ''}`} key={`section-${i}`}>
                            {this.renderView(i)}
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default ContactForm;
